import Storage from "services/Storage";

export const isExpired = (expiry: number): boolean => {
  return expiry < new Date().getTime();
};

export const logout = () => {
  Storage.removeToken();
};
